module.exports = {
	"_args": [
		[
			"babel-core@^6.0.0",
			"C:\\Sources\\rsamec\\react-designer"
		]
	],
	"_from": "babel-core@>=6.0.0 <7.0.0",
	"_id": "babel-core@6.8.0",
	"_inCache": true,
	"_installable": true,
	"_location": "/babel-core",
	"_nodeVersion": "5.1.0",
	"_npmOperationalInternal": {
		"host": "packages-16-east.internal.npmjs.com",
		"tmp": "tmp/babel-core-6.8.0.tgz_1462232632036_0.29488914273679256"
	},
	"_npmUser": {
		"email": "hi@henryzoo.com",
		"name": "hzoo"
	},
	"_npmVersion": "3.8.6",
	"_phantomChildren": {},
	"_requested": {
		"name": "babel-core",
		"raw": "babel-core@^6.0.0",
		"rawSpec": "^6.0.0",
		"scope": null,
		"spec": ">=6.0.0 <7.0.0",
		"type": "range"
	},
	"_requiredBy": [
		"#DEV:/",
		"/babel-plugin-transform-regenerator",
		"/babel-register",
		"/isparta"
	],
	"_resolved": "https://registry.npmjs.org/babel-core/-/babel-core-6.8.0.tgz",
	"_shasum": "52fde0b4c05d9eb7f60ada3c75666238f14d1420",
	"_shrinkwrap": null,
	"_spec": "babel-core@^6.0.0",
	"_where": "C:\\Sources\\rsamec\\react-designer",
	"author": {
		"email": "sebmck@gmail.com",
		"name": "Sebastian McKenzie"
	},
	"dependencies": {
		"babel-code-frame": "^6.8.0",
		"babel-generator": "^6.8.0",
		"babel-helpers": "^6.8.0",
		"babel-messages": "^6.8.0",
		"babel-register": "^6.8.0",
		"babel-runtime": "^6.0.0",
		"babel-template": "^6.8.0",
		"babel-traverse": "^6.8.0",
		"babel-types": "^6.8.0",
		"babylon": "^6.7.0",
		"convert-source-map": "^1.1.0",
		"debug": "^2.1.1",
		"json5": "^0.4.0",
		"lodash": "^3.10.0",
		"minimatch": "^2.0.3",
		"path-exists": "^1.0.0",
		"path-is-absolute": "^1.0.0",
		"private": "^0.1.6",
		"shebang-regex": "^1.0.0",
		"slash": "^1.0.0",
		"source-map": "^0.5.0"
	},
	"description": "Babel compiler core.",
	"devDependencies": {
		"babel-helper-fixtures": "^6.8.0",
		"babel-helper-transform-fixture-test-runner": "^6.8.0",
		"babel-polyfill": "^6.8.0"
	},
	"directories": {},
	"dist": {
		"shasum": "52fde0b4c05d9eb7f60ada3c75666238f14d1420",
		"tarball": "https://registry.npmjs.org/babel-core/-/babel-core-6.8.0.tgz"
	},
	"homepage": "https://babeljs.io/",
	"keywords": [
		"6to5",
		"babel",
		"classes",
		"const",
		"es6",
		"harmony",
		"let",
		"modules",
		"transpile",
		"transpiler",
		"var"
	],
	"license": "MIT",
	"maintainers": [
		{
			"name": "amasad",
			"email": "amjad.masad@gmail.com"
		},
		{
			"name": "hzoo",
			"email": "hi@henryzoo.com"
		},
		{
			"name": "jmm",
			"email": "npm-public@jessemccarthy.net"
		},
		{
			"name": "loganfsmyth",
			"email": "loganfsmyth@gmail.com"
		},
		{
			"name": "sebmck",
			"email": "sebmck@gmail.com"
		},
		{
			"name": "thejameskyle",
			"email": "me@thejameskyle.com"
		}
	],
	"name": "babel-core",
	"optionalDependencies": {},
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "https://github.com/babel/babel/tree/master/packages/babel-core"
	},
	"scripts": {
		"bench": "make bench",
		"test": "make test"
	},
	"version": "6.8.0"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/package.json
 ** module id = 962
 ** module chunks = 0
 **/